export const HANDLE_REGEX = /^@?[a-z0-9_.]{1,50}$/i;

export default function handle(value = '') {
  if (['', undefined, null].includes(value)) {
    return false;
  }

  if (typeof value === 'string' && HANDLE_REGEX.test(value)) {
    return false;
  }

  return true;
}

handle.message = function message(value, options = {}) {
  return options.message || 'precisa ser um @ válido';
};
